function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(-78.5 -220)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M98.881,0H0",
  transform: "translate(78.619 221)",
  fill: "none",
  stroke: "#77c4ff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_33",
  "data-name": "Line 33",
  y1: 87.5,
  transform: "translate(910.5 221)",
  fill: "none",
  stroke: "#77c4ff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_32",
  "data-name": "Line 32",
  x1: 71,
  transform: "translate(839.5 308.5)",
  fill: "none",
  stroke: "#77c4ff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_28",
  "data-name": "Line 28",
  y1: 776,
  transform: "translate(79.5 221.5)",
  fill: "none",
  stroke: "#77c4ff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_29",
  "data-name": "Line 29",
  x1: 1751,
  y1: 1,
  transform: "translate(79 997)",
  fill: "none",
  stroke: "#77c4ff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_31",
  "data-name": "Line 31",
  x1: 920,
  transform: "translate(910 221)",
  fill: "none",
  stroke: "#77c4ff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_30",
  "data-name": "Line 30",
  y2: 779,
  transform: "translate(1830.5 220.5)",
  fill: "none",
  stroke: "#77c4ff",
  strokeWidth: 2
}));

function SvgBorderCosmicDrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1753 779.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderCosmicDrive);
export default __webpack_public_path__ + "static/media/border-cosmic-drive.b8399665.svg";
export { ForwardRef as ReactComponent };